import { IAdFoxBannerOnLoadData, IAdFoxBannerOnErrorError } from '@cian/adfox-component';
import * as React from 'react';
import { useApplicationContext } from '../../utils/applicationContext';
import { NewAdfoxBanner } from '../NewAdfoxBanner';
import { IAdfoxConstants } from './constants';
import { ErrorBoundary } from '../ErrorBoundary';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { useAdsDisabled } from '../../../browser/utils/hooks/useAdsDisabled';
import { useAdfoxParams } from '../../utils/adfox';
import type { InitialAdfoxAnalyticsPayload } from '@cian/postview-analytics-utils';

export interface IAdfoxNewProps {
  constants: IAdfoxConstants;
  postViewAnalyticsData: Pick<InitialAdfoxAnalyticsPayload, 'place' | 'isSp'>;
  onLoad?(data: IAdFoxBannerOnLoadData): void;
  onStub?(): void;
  onError?(error: IAdFoxBannerOnErrorError): void;
}

const AdfoxNewComponent: React.FC<IAdfoxNewProps> = props => {
  const { logger } = useApplicationContext();
  const { onStub, constants } = props;

  const adfoxParams = useAdfoxParams(constants);

  const onError = React.useCallback(
    (error: Error) => {
      logger.error(error, {
        message: 'Failed to render adfox banner',
        domain: 'AdfoxNew',
      });

      if (onStub) {
        onStub();
      }
    },
    [onStub, logger],
  );

  if (!adfoxParams) {
    return null;
  }
  /* oxlint-disable typescript/no-unused-vars */
  const { pr, pr1, ...rest } = adfoxParams;

  return (
    <ErrorBoundary onError={onError}>
      <NewAdfoxBanner
        params={rest}
        onLoad={props.onLoad}
        onStub={props.onStub}
        onError={props.onError}
        postViewAnalyticsData={props.postViewAnalyticsData}
        width="100%"
        height={80}
      />
    </ErrorBoundary>
  );
};

export const AdfoxNew: React.FC<IAdfoxNewProps> = props => {
  const isAdsDisabled = useAdsDisabled(() => {
    if (props.onStub) {
      props.onStub();
    }
  }, [props.onStub]);

  if (isAdsDisabled) {
    return null;
  }

  return <AdfoxNewComponent {...props} />;
};
